module.exports = __webpack_public_path__ + "static/makook-dirha-darkmode-5bd53ee2e9057e25dfa429cbec4572c5.mp4";